import { Dropdown } from '@platform/ui-library';
import { FC, useEffect } from 'react';
import { channelTypeOptions } from '../../const';
import { useDesign } from '../../hooks';
import { useGlobalSettings } from '../../stores';
import { DesignChannelType } from '../../types';

type ChannelSelectorProps = {
  onChange?: () => void;
};

export const ChannelSelector: FC<ChannelSelectorProps> = ({ onChange }) => {
  const { channels, defaultChannel } = useDesign().rootSettings;
  const { channel, setSettings } = useGlobalSettings();

  useEffect(() => {
    if (!channel || !(channel in channels)) {
      handleChange(defaultChannel);
    }
  }, [channel, channels, setSettings]);

  const handleChange = (newChannel: string) => {
    setSettings({ channel: newChannel as DesignChannelType });
    window.apm.setSerializedChanged();
    window.apm.postEventToCurrentView({ target: 'request-refresh' });
    onChange?.();
  };

  return (
    <Dropdown
      className="selector"
      options={Object.fromEntries(
        channelTypeOptions.filter((option) => {
          return option.value in channels;
        }).map(({ name, value }) => {
          const label = (value !== defaultChannel) ? name : (
            <>
              {name}<small>(default)</small>
            </>
          );
          return [value, label];
        })
      )}
      onChange={handleChange}
      value={channel ?? defaultChannel}
    />
  );
};
